import { debounce } from '@repo/utils/debounce'
import { ospreyAPI } from '@repo/api/ospreyAPI'
import { storeWrapper } from '../storeWrapper'

const initialState = {
  newMatterDefaults: {},
  newMatterDefaultsData: {
    branchId: null,
    departmentId: null,
    feeEarnerId: null,
    matterDescription: null,
    newMatterDefaultId: null,
    notificationRecipientUserId: null,
    notificationSourceId: null,
    sourceWorkTypeId: null,
    sourceWorkTypeName: null,
    supervisingFeeEarnerId: null,
    workTypeId: null
  },
  thirdPartyCaseTypesData: []
}

export const useThirdPartyCaseTypesStore = storeWrapper('useThirdPartyCaseTypesStore', (set, get) => ({
  ...initialState,
  setNewMatterDefaultData: ({ newMatterDefaultsData }) => {
    set({
      newMatterDefaultsData: {
        ...newMatterDefaultsData
      }
    })
  },
  fetchThirdPartyCaseTypes: async ({ thirdPartyService }) => {
    debounce({
      id: `fetchThirdPartyCaseTypes-${thirdPartyService}`,
      callback: async () => {
        const thirdPartyCaseTypesData = await ospreyAPI({
          service: thirdPartyService,
          endpoint: 'WorkType/GetAll'
        })

        set({ thirdPartyCaseTypesData })

        return Promise.resolve()
      }
    })
  },
  fetchSingleNewMatterDefault: async ({ newMatterDefaultId }) => {
    debounce({
      id: `fetchSingleNewMatterDefault-${newMatterDefaultId}`,
      delay: 3000,
      callback: async () => {
        let fetchSingleNewMatterDefaultsData = await ospreyAPI({
          service: 'notifications',
          endpoint: `NewMatterDefaults/GetComplete`,
          data: {
            newMatterDefaultId: newMatterDefaultId
          }
        })

        set({ newMatterDefaultsData: fetchSingleNewMatterDefaultsData })
      }
    })
  },
  fetchNewMatterDefaults: async ({ sourceId }) => {
    debounce({
      id: `fetchNewMatterDefaults-${sourceId}`,
      delay: 3000,
      callback: async () => {
        let fetchedNewMatterDefaults = await ospreyAPI({
          service: 'notifications',
          endpoint: `NewMatterDefaults/GetAllComplete`,
          data: {
            sourceId: sourceId
          }
        })

        set({
          newMatterDefaults: fetchedNewMatterDefaults
        })
      }
    })
  },
  createNewMatterDefault: async () => {
    debounce({
      id: `createNewMatterDefault-${get().newMatterDefaultId}`,
      delay: 100,
      callback: async () => {
        let createdNewMatterDefault = await ospreyAPI({
          method: 'POST',
          service: 'notifications',
          endpoint: `NewMatterDefaults/Create`,
          data: get().newMatterDefaultsData
        })

        set((state) => ({
          newMatterDefaults: [...state.newMatterDefaults, createdNewMatterDefault]
        }))
      }
    })
  },
  updateNewMatterDefaults: async () => {
    const defaultsData = get().newMatterDefaultsData

    const payload = {
      ...defaultsData,
      branchId: defaultsData?.branchId?.branchId || defaultsData?.branchId || null,
      departmentId: defaultsData?.departmentId?.departmentId || defaultsData?.departmentId || null,
      feeEarnerId: defaultsData?.feeEarnerId?.feeEarnerId || defaultsData?.feeEarnerId || null,
      supervisingFeeEarnerId:
        defaultsData?.supervisingFeeEarnerId?.feeEarnerId || defaultsData?.supervisingFeeEarnerId || null,
      workTypeId: defaultsData?.workTypeId?.workflowTypeId || defaultsData?.workTypeId || null
    }

    debounce({
      id: `updateNewMatterDefaults-${get().newMatterDefaultsData.newMatterDefaultId}`,
      delay: 100,
      callback: async () => {
        await ospreyAPI({
          method: 'PUT',
          service: 'notifications',
          endpoint: `NewMatterDefaults/Update`,
          data: payload
        })

        return Promise.resolve()
      }
    })
  },
  deleteNewMatterDefault: async ({ newMatterDefaultId }) => {
    debounce({
      id: `deleteNewMatterDefault-${newMatterDefaultId}`,
      delay: 100,
      callback: async () => {
        await ospreyAPI({
          method: 'DELETE',
          service: 'notifications',
          endpoint: `NewMatterDefaults/Delete?id=${newMatterDefaultId}`
        })
      }
    })
  },
  reset: () => set(initialState)
}))
